import PropTypes from 'prop-types';
import Icon from '@encodium/rp-ui/components/icon';

export const productMedia3dModelErrorClassNamesPropType = PropTypes.shape({
	container: PropTypes.string.isRequired,
	icon: PropTypes.string.isRequired,
	message: PropTypes.string.isRequired,
});

export default function ProductMedia3dModelError({ classNames, message }) {
	return (
		<div className={classNames.container} role="alert" aria-live="polite">
			<span className={classNames.icon} aria-hidden="true">
				<Icon color="currentColor" name="cube3dRotation" width={100} />
			</span>
			<p className={classNames.message}>{message}</p>
		</div>
	);
}

ProductMedia3dModelError.displayName = 'ProductMedia3dModelError';

ProductMedia3dModelError.propTypes = {
	classNames: productMedia3dModelErrorClassNamesPropType.isRequired,
	message: PropTypes.string.isRequired,
};
